module.exports = __webpack_public_path__ + "files/b4c95d4b8bd9b44243ba920dc33f4f28.png";